export const ICONS = {
  DASHBOARD: 'assets/icons/DashboardNav.svg',
  IDENTITY: 'assets/icons/IdentityNav.svg',
  PAT: 'assets/icons/PatrimoineNav.svg',
  LEGACY: 'assets/icons/LegacyNav.svg',
  ACCOUNT: 'assets/icons/Account.svg',


  GEAR: 'assets/icons/params.svg',
  NOTIFICATION: 'assets/icons/notifs.svg',
  BOY_LIGHT_SKIN: 'assets/icons/boy_light-skin-tone.png',

  INFO: 'assets/icons/Info.png',
  MAGIC: 'assets/icons/Magic.png',

  CHECKED_TICK: 'assets/icons/CheckCircleFill.svg',
  CHECKED_PINK_TICK: 'assets/icons/CheckCircleFillPink.svg',
  CHECKED_WHITE_TICK: 'assets/icons/CheckWhiteCircle.svg',
  CHECKED_TICK_SQUARE: 'assets/icons/image19.svg',

  ADD_ICON: 'assets/icons/Add.svg',
  ADD_FILL_YELLOW: 'assets/icons/AddFillYellow.svg',
  ADD_FILL_BLUE: 'assets/icons/AddFillBlue.svg',
  ADD_FILL_PINK: 'assets/icons/AddFillPink.svg',
  ADD_WHITE: 'assets/icons/white-add.png',
  EDIT_ICON: 'assets/icons/Edit.svg',
  EDIT_FILL_YELLOW: 'assets/icons/EditFillYellow.svg',
  EDIT_FILL_BLUE: 'assets/icons/EditFillBlue.svg',
  EDIT_FILL_PINK: 'assets/icons/EditFillPink.svg',

  CLOUD_UPLOAD: 'assets/icons/UploadCloud.svg',
  INFO_FILL: 'assets/icons/InfoFill.svg',
  INFO_FILL_P: 'assets/icons/InfoFillP.svg',
  INFO_FILL_A: 'assets/icons/InfoFillA.svg',

  LEFT_HAND: 'assets/icons/handLeft.png',
  LEFT_ARROW: 'assets/icons/ArrowLeft.svg',
  LEFT_BLUE_ARROW: 'assets/icons/ArrowLeftBlue.svg',
  LEFT_PINK_ARROW: 'assets/icons/ArrowLeftPink.svg',
  LEFT_YELLOW_ARROW: 'assets/icons/ArrowLeftYellow.svg',
  RIGHT_ARROW: 'assets/icons/ArrowRight.svg',
  RIGHT_LIGHT_BLUE_ARROW: 'assets/icons/ArrowRightLightBlue.svg',

  CARD: 'assets/icons/image31.png',
  DOWNLOAD: 'assets/icons/Download.svg',
  DOWNLOAD_DOC: 'assets/icons/image31.png',

  WISHES: 'assets/icons/image22.png',
  CEREMONY: 'assets/icons/image30.png',

  CLAP: 'assets/icons/image9.png',
  REWARD: 'assets/icons/Reward.svg',

  HOUSE: 'assets/icons/Houses.png',
  CLOSE: 'assets/icons/Close.svg',
  CLOSE_FILL: 'assets/icons/Close2Fill.png',

  SHARE: 'assets/icons/Share2.png',
  ANONYMOUS: 'assets/icons/AccountFillL.png',
  ANONYMOUS_BG_NONE: 'assets/icons/anonymous-avatar.png',
  ALEXIA: 'assets/icons/alexia.png',
  HOME: 'assets/icons/BiensImmobiliers.svg',

  TRASH: 'assets/icons/Trash.svg',
  FOLDERS: 'assets/icons/folders.png',
  DASHBOARD_PAT: 'assets/icons/pat.svg',
  DASHBOARD_VOL: 'assets/icons/volontes.svg',
  DASHBOARD_PAT2: 'assets/icons/pat2.svg',
  DASHBOARD_CER: 'assets/icons/cere.svg',
  MEMORIES_PINK: 'assets/icons/memories.svg'
};
export const GIRL = 'assets/icons/girl.png';
